export default "__VITE_ASSET__DDNa2sEE__"